import React from "react";
import { Button, Modal } from "react-bootstrap";
import { JsonView, defaultStyles } from 'react-json-view-lite';
import "react-json-view-lite/dist/index.css";

const ViewMetaDataPopup = ({ showPopup, closePopup, data }) => {
    const hideHandler = () => {
      closePopup();
    };

    return (
        <Modal
            show={showPopup}
            onHide={hideHandler}
            backdrop="static"
            keyboard={false}
            centered
            className={`custom-mail-sent-modal`}
        >
            <Modal.Body>
              <div className="p-2">
              <JsonView
                data={data}
                shouldExpandNode={(level) => level < 2}
                style={{
                  ...defaultStyles,
                  container: "background: transparent; color: #dcdcdc;",
                  key: "color: #9cdcfe;",
                  number: "color: #b5cea8;",
                  string: "color: #ce9178;",
                  boolean: "color: #569cd6;",
                  null: "color: #808080;",
                }}
                clickToExpandNode
              />
              </div>

              <div className="d-flex justify-content-center mt-2">
                <Button
                  type="button"
                  style={{ height: "30px", minWidth: "60px" }}
                  onClick={hideHandler}
                  className={`btn text-white commonBtn fw-sbold`}
                >
                  Close
                </Button>
              </div>
            </Modal.Body>
        </Modal>
    );
};

export default ViewMetaDataPopup;
